/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserCredentialsResponse } from '../../models/get-user-credentials-response';

export interface AdminServiceGetUserCredentials$Params {
  discordId: string;
}

export function adminServiceGetUserCredentials(http: HttpClient, rootUrl: string, params: AdminServiceGetUserCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserCredentialsResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetUserCredentials.PATH, 'get');
  if (params) {
    rb.path('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserCredentialsResponse>;
    })
  );
}

adminServiceGetUserCredentials.PATH = '/api/v3/gateway/user/{discordId}/credentials';
